// extracted by mini-css-extract-plugin
export default {"column":"CheckboxGroup_column__KDZPU"};